module.exports = __webpack_public_path__ + "img/lock.228c415b.svg";